<div class="border-2 rounded-lg my-4" [ngClass]="{'pb-2': title === 'Email'}">
  <div class="bg-primary-300 flex items-center justify-between p-2 rounded-md rounded-b-none shadow-sm">
    <div class="flex items-center space-x-2">
      <span class="font-semibold text-green-900 dark:text-black">{{ title }} to:</span>
      <span class="text-green-900">..</span>
      <span class="bg-primary text-black dark:text-white text-xs px-2 py-1 rounded">Default</span>
    </div>

    <div class="relative">
      <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item>
          <mat-icon>dialpad</mat-icon>
          <span>Redial</span>
        </button>
        <button mat-menu-item disabled>
          <mat-icon>voicemail</mat-icon>
          <span>Check voice mail</span>
        </button>
        <button mat-menu-item>
          <mat-icon>notifications_off</mat-icon>
          <span>Disable alerts</span>
        </button>
      </mat-menu>
    </div>

  </div>

  <ng-content></ng-content>


  <div class="bg-gray-100 flex items-center justify-between p-2 rounded-md rounded-t-none shadow-sm mt-4 dark:bg-slate-700"
       *ngIf="title !== 'Email' ">
    <span class="text-black dark:text-gray-300 text-lg font-semibold ml-4 w-3/12"> Shipping Method </span>
    <mat-form-field class="mr-4 w-5/12">
      <mat-select (selectionChange)="onShippingMethodChange($event)">
        <mat-option value="1">Us mala</mat-option>
        <!--<mat-option *ngFor="let type of uniquePermissionTypes" [value]="type">
          {{ type }}
        </mat-option>-->
      </mat-select>
    </mat-form-field>
  </div>
</div>
